/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = function () { /* empty */ };

